import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet-async";
import apiMiddleware from '../Utility/middleware';
import AlertPopUP from '../GlobalComponents/Shedule-Maintanc/AlertPopUP';
import DevicesGet from '../Utility/DevicesGet';

const Alert = () => {
  const [alertSettings, setAlertSettings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
    const [AlertData, setAlertData] = useState([]);
    const [SaveMenu, setSaveMenu] = useState(false);
  // Fetch current alert settings from the database
  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      const body = {
        queryType: 'custom-query',
        table: 'SETTING_TBL',
        data: {
          query: "SELECT * FROM SETTING_TBL WHERE 1",
        },
      };

      const response = await apiMiddleware('POST', body);

      if (response.success) {
        setAlertSettings(response.data);
      } else {
        console.error('Failed to fetch settings:', response.error);
      }
      setLoading(false);
    };

    fetchSettings();
 
  }, []);






  
  













  // Handle checkbox and select input changes
  const handleInputChange = (id, field, value) => {
    setSaveMenu(true);
    setAlertSettings((prev) =>
      prev.map((alert) =>
        alert.ID === id ? { ...alert, [field]: value } : alert
      )
    );
  };

  const handleSave = async () => {


    // confirm before saving
    if (!window.confirm('Are you sure you want to save the changes?')) {
      return;
    }
    if (alertSettings.length === 0) return;

    for (const alert of alertSettings) {
      const body = {
        queryType: 'custom-query',
        table: 'SETTING_TBL',
        data: {
          query: `
            UPDATE SETTING_TBL 
            SET 
              IS_EMAIL = ${alert.IS_EMAIL ? 1 : 0}, 
              IS_WEB = ${alert.IS_WEB ? 1 : 0}, 
              IS_INDIVIDUAL = ${alert.IS_INDIVIDUAL ? 1 : 0}, 
              EMAIL_ID = '${alert.EMAIL_ID}', 
              MODIFY_DATE = '${new Date().toISOString()}' 
            WHERE ID = ${alert.ID};
          `,
        },
      };

      const response = await apiMiddleware('POST', body);
      setSaveMenu(false);
      if (!response.success) {
        console.error('Failed to update settings for ID:', alert.ID, response.error);
      }
    }
   
    setAlertData([

      {
        type: 'success',
        title: 'Hurray! Data Updated successfully',
        message: 'Hurray! Data Updated successfully'
      }
    ])
    setShowAlert(true);
  };

  return (
    <>
      <Helmet>
        <title>Alerts</title>
      </Helmet>

      {showAlert && (
          <AlertPopUP
            type={AlertData[0]?.type} // or "info" based on your needs
            title={AlertData[0]?.title}
            message={AlertData[0]?.message}
            onCloseAlert={() => setShowAlert(false)}
          />
        )}
      <section className="bg-SoftBlack min-h-screen py-10 flex flex-col items-center justify-center">
        <div className="bg-gray-800 text-white p-6 rounded-md h-96  w-[95%] md:w-[70%]">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table className="w-full text-left">
              <thead>
                <tr className=' md:text-base text-sm'>
                  <th className="pb-4">NAME OF THE ALERT</th>
                  <th className="pb-4 text-center">EMAIL</th>
                  <th className="pb-4 text-center">WEB</th>
                  <th className="pb-4 text-center">FREQUENCY</th>
                </tr>
              </thead>
              <tbody>
                {alertSettings.map((alert) => (
                  <tr key={alert.ID} className="border-t border-gray-700">
                    <td className="py-4">{alert.ALERT_NAME}</td>
                    <td className="py-4 text-center">
                      <input
                        type="text"
                        name="Email"
                        value={alert.EMAIL_ID}
                        placeholder="Enter email"
                        className="border p-2 w-full rounded bg-SoftBlack"
                        onChange={(e) =>
                          handleInputChange(alert.ID, 'EMAIL_ID', e.target.value)
                        }
                        required
                      />
                    </td>
                    <td className="py-4 text-center">
                      <input
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-blue-600"
                        checked={alert.IS_EMAIL}
                        onChange={(e) =>
                          handleInputChange(alert.ID, 'IS_EMAIL', e.target.checked)
                        }
                      />
                    </td>
                    <td className="py-4 text-center">
                      <input
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-blue-600"
                        checked={alert.IS_WEB}
                        onChange={(e) =>
                          handleInputChange(alert.ID, 'IS_WEB', e.target.checked)
                        }
                      />
                    </td>
                    <td className="py-4">
                      <select
                        value={alert.IS_INDIVIDUAL ? 'Individual' : 'Digest'}
                        onChange={(e) =>
                          handleInputChange(
                            alert.ID,
                            'IS_INDIVIDUAL',
                            e.target.value === 'Individual' ? 1 : 0
                          )
                        }
                        className="bg-gray-700 text-white p-2 rounded-md w-full"
                      >
                        <option value="Individual">Individual</option>
                        <option value="Digest">Digest</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Button Section */}
        <div className="w-full flex items-center justify-center mt-8 px-4 lg:px-0">
          <div className={` ${SaveMenu ? 'flex':'hidden'} flex justify-between items-center w-full max-w-xs md:max-w-sm lg:max-w-md space-x-4`}>
            <button
              className="rounded-3xl bg-white text-black py-3 px-6 md:px-10"
              onClick={() => window.location.reload()}
            >
              Cancel
            </button>
            <button
              className="rounded-3xl bg-DarkRed text-white py-3 px-6 md:px-10"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Alert;
